/**
[
  {
     "align": (left|right),
     "directionImg": imgId | base64,
     "rows":	[{
     			  "icon": imgId | base64,
     			  "tekst": tekst
     			  },
     			  {
     			  "icon": imgId | base64,
     			  "tekst": tekst
     			  }
     			]
  },
  {
     "align": (left|right),
     "directionImg": imgId | base64,
     "rows":	[{"icon": imgId | base64,
     			  "tekst": tekst
     			  }
     			]
  }
]
**/
/*
const test = {
    "id": 9,
    "contentType": "WYS",
    "position": "middle",
    "level": "1",
    "content": [{
      "icon": <base64>,
      "text": "Station Tilburg"
      },
      {
        "icon": <base64>,
        "text": "Spoorlaan"
      }
    ],
    "validity": {
        "from": "2018-02-16 16:50:00",
        "to": "2018-03-11 11:55:00"
    },
    "lastUpdate": "2018-02-23 11:47:18.139",
    "minimalDuration": "1",
    "directionInfo": {
        "align": "left",
        "directionImg": <base64>,
    }
};
*/

class WegbewijzeringController {
  constructor($compile, $element, $scope, utils) {
    this.$compile = $compile;
    this.$element = $element;
    this.$scope = $scope;
    this.utils = utils;
    this.content = null;
  }

  $onInit() {
  }

  getIconUrl(base64) {
    if (base64) {
      return {
        'background-image': `url(${this.utils.getBase64Src(base64)})`
      }
    }
  }
}

export default WegbewijzeringController;



// WEBPACK FOOTER //
// ./client/app/components/content-types/wegbewijzering/wegbewijzering.controller.js